import React from 'react';
import { useCurrentCategory } from '@rocco/ui/website-header/hooks/use-current-category';
import OverviewPage from '@modules/professional/page/OverviewPage';
import { loader } from '@modules/professional/page/loaders/overview-page-loader.server';
import { getPreloadImageLink } from '~/modules/images';
import type { APHandle } from '~/modules/root';
import { mergeMeta } from '~/modules/seo';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data } = props;
        const bannerImage =
            data?.banners &&
            data.banners.length > 0 &&
            data.banners[0]?.libraryImageFile?.DetailBannerStandard?.Desktop;

        if (bannerImage) {
            if (data.deviceType === 'mobile') {
                return getPreloadImageLink(undefined, bannerImage);
            }
            return getPreloadImageLink(bannerImage);
        }

        return [];
    }
);

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    isOverviewPage: true,
    hideContactArchiPro: true,
};

export { loader };

const ProfessionalPage = () => {
    const { setCategory } = useCurrentCategory();

    // Set the current category for header navigation
    React.useEffect(() => {
        setCategory('Professionals');
        return () => setCategory(null);
    }, [setCategory]);

    return <OverviewPage />;
};

export default ProfessionalPage;
